import React, { useEffect } from "react";
import { UserInformationSection } from "pages/Users/UserProfileInfo/styled";
import RadioLabelComponent from "components/Toggles/RadioLabelComponent";

export const EditProfileInfo = ({
  creatorUserDetails,
  editInformation,
  setEditInformation
}) => {
  useEffect(() => {
    if (creatorUserDetails) {
      setEditInformation({
        ...editInformation,
        skip_criteria_check_for_social:
          creatorUserDetails.skip_criteria_check_for_social === 1 ? true : false
      });
    }
  }, [creatorUserDetails]);
  return (
    <>
      <UserInformationSection>
        <h3 className="section-title">Minimum Follower Requirement</h3>
        <div className="edit-info-container">
          <RadioLabelComponent
            checked={editInformation.skip_criteria_check_for_social}
            labelHeader="Yes"
            labelDescription="Allow creator to join even if he has fewer than 5,000 Instagram followers or fewer than 1,000 YouTube subscribers."
            onChange={() =>
              setEditInformation({
                ...editInformation,
                skip_criteria_check_for_social: true
              })
            }
          />
          <RadioLabelComponent
            checked={!editInformation.skip_criteria_check_for_social}
            labelHeader="No"
            labelDescription="Do not allow creator to join if he has fewer than 10,000 Instagram followers or fewer than 1,000 YouTube subscribers."
            onChange={() =>
              setEditInformation({
                ...editInformation,
                skip_criteria_check_for_social: false
              })
            }
          />
          <div className="note-info-section">
            <span>NOTE:</span>
            <p>This action creates an exception for this creator only.</p>
          </div>
        </div>
      </UserInformationSection>
    </>
  );
};
